<mat-card>
  <h2 i18n="available surveys@@available_surveys">Available Surveys</h2>
  @if (assignedSurveys && assignedSurveys.length > 0) {
    <mat-list>
      @for (s of assignedSurveys; track s) {
        <mat-list-item
          style="height: auto; padding-top: 2vh; padding: 100px"
          class="mat-list-item-content_new"
          >
          <mat-divider></mat-divider>
          <div>
            <p i18n="survey@@survey">Survey:{{ s.surveyName && s.surveyName }}<br />{{ s.data_year && s.data_year.name }}</p>
            <p i18n="last_update@@last_update">Last Update: {{ s.lastUpdated || "-" }}</p>
          </div>
          <label style="flex: 1 1 auto"></label>
          <button mat-raised-button (click)="updateSurvey(s)" i18n="update collections@@update_collections">
          Update collections
        </button>
          <label style="flex: 1 1 auto"></label>
          @if (true || s.kobo_formulas && s.kobo_formulas.length > 0) {
            <div
              style="max-width: 40%; width: 40%; padding-bottom: 20px"
              i18n="formulas@@formulas"
              >
          Formulas:
          <div>
            <mat-chip-listbox>
              @for (f of s.kobo_formulas; track f) {
<mat-chip-option>
                {{ f.formulaName }} | <mat-icon  (click)="openConfirmDialog('formula', s, f);" class="close-icon" aria-label="Close icon" matTooltip="Close">close</mat-icon>
              </mat-chip-option>
}
            </mat-chip-listbox>
              <button mat-raised-button (click)="openAddFormulaAssignmentDialog(s)">
                Add formula
              </button>
          </div>
        </div>
          }
          <label style="flex: 1 1 auto"></label>
          <button mat-raised-button color="warn" (click)="openConfirmDialog('survey', s, null);" i18n="remove assignment@@remove_assignment">
          Delete imported survey
        </button>
        </mat-list-item>
      }
    </mat-list>
  }
  @if (!assignedSurveys || assignedSurveys.length === 0) {
    <div i18n="no assigned surveys found, laod new surveys and assign them@@no_assigned_surveys">
    No assigned surveys found. Load new surveys and assign them!
  </div>
  }
  <div style="padding-left: 16px;">
    <h2 style="margin-top: 32px; margin-bottom: 16px;" i18n="import new sets@@import_new_sets">Import new sets</h2>
    @if (!loadingSurveys) {
      <div style="margin-bottom: 16px;">
        <button mat-raised-button color="primary" (click)="loadKoboSurveys()" i18n="load new surveys@@load_new_surveys">
        Load new surveys
      </button>
      </div>
    }
    @if (loadingSurveys) {
      <div style="margin: 16px 0;">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
  @if (newSurveys && newSurveys.length > 0) {
    <div style="margin-top: 16px; padding-left: 16px;">
      @for (ns of newSurveys; track ns; let i = $index) {
        <div style="display: flex; align-items: center; padding: 16px 16px 16px 0; border-bottom: 1px solid #e0e0e0;">
          <div style="width: 10vw; padding-right: 2vw; margin-right: 2vw">
            {{ ns.name }}
            <div style="font-size: x-small">UID: {{ ns.uid }}</div>
          </div>
          <div style="padding-right: 2vw; margin-right: 2vw" i18n="no entries@@no_entries">
        No Entries:{{ ns.deployment__submission_count }}
      </div>
          <button
            mat-button
            [matMenuTriggerData]="{ data: { uid: ns.uid, position: i } }"
            [matMenuTriggerFor]="assignProject"
            i18n="assign project@@assign_project"
            >
        Assign project
      </button>
          @if (ns.project) {
            <div style="padding-right: 2vw; margin-right: 2vw">
              {{ ns.project.name }}
            </div>
          }
          @if (ns.project) {
            <div>
              <button
                mat-button
                [matMenuTriggerFor]="assignYear"
                [matMenuTriggerData]="{ years: ns.project.data_years, uid: ns.uid }"
                i18n="assign year@@assign_year"
                >
          Assign year
        </button>
            </div>
          }
          @if (ns.dataYear) {
            <div style="padding-right: 2vw; margin-right: 2vw">
              {{ ns.dataYear.year }}
            </div>
          }
          @if (ns.dataYear) {
            <div>
              <button
                [disabled]="loadingSurveys"
                mat-raised-button
                color="primary"
                (click)="saveNewSurvey(ns)"
                i18n="save new survey@@save_new_survey"
                >
          Save imported survey
        </button>
            </div>
          }
        </div>
      }
    </div>
  }
  @if (newSurveys && newSurveys.length === 0) {
    <div style="padding-left: 16px; margin-top: 16px;" i18n="no unassigned surveys@@no_unassigned_surveys_admin">
    No unassigned surveys found, please contact the KOBO admin
  </div>
  }
</mat-card>

<mat-menu #assignProject="matMenu">
  <ng-template matMenuContent let-data="data">
    @for (p of projects; track p) {
      <button
        mat-menu-item
        (click)="selectProject(data.uid, data.position, p)"
        >
        {{ p.name }}
      </button>
    }
  </ng-template>
</mat-menu>

<mat-menu #assignYear="matMenu">
  <ng-template matMenuContent let-years="years" let-uid="uid">
    @for (y of sortYears(years); track y) {
      <button
        mat-menu-item
        (click)="selectYear(uid, y)"
        >
        {{ y.year }}
      </button>
    }
  </ng-template>
</mat-menu>
